import { Text } from '@/components/design-system'

interface GoalsData {
  role_in_company: string
  use_cases: string[]
}

interface Props {
  data: GoalsData
  onChange: (field: keyof GoalsData, value: string | string[]) => void
}

const ROLE_OPTIONS = [
  'Dono(a) / Fundador(a)',
  'Sócio(a)',
  'Diretor(a)',
  'Gerente',
  'Coordenador(a)',
  'Analista',
  'Consultor(a) / Agência',
  'Outro',
]

const USE_CASE_OPTIONS = [
  'Gestão de anúncios (Meta, Google)',
  'Catálogo e produtos',
  'Atendimento ao cliente',
  'Análise de dados e relatórios',
  'Gestão de marketplaces',
  'Logística e fulfillment',
  'Outro',
]

export default function GoalsStep({ data, onChange }: Props) {
  const toggleUseCase = (useCase: string) => {
    const current = data.use_cases
    const updated = current.includes(useCase)
      ? current.filter((u) => u !== useCase)
      : [...current, useCase]
    onChange('use_cases', updated)
  }

  return (
    <div className="space-y-8">
      <div>
        <Text as="h1" size="display-small" className="font-bold text-foreground">
          Como podemos ajudar você?
        </Text>
        <Text as="p" size="body-large" color="subdued" className="mt-2">
          Isso nos ajuda a personalizar sua experiência.
        </Text>
      </div>

      <div className="space-y-6">
        <div>
          <Text as="label" size="body-small" className="mb-3 block font-medium text-muted-foreground">
            Qual sua função?
          </Text>
          <div className="flex flex-wrap gap-2">
            {ROLE_OPTIONS.map((role) => (
              <button
                key={role}
                type="button"
                onClick={() => onChange('role_in_company', role)}
                className={`rounded-full border px-4 py-2 text-sm font-medium transition-colors ${
                  data.role_in_company === role
                    ? 'border-border bg-accent text-foreground'
                    : 'border-border bg-background text-muted-foreground hover:border-border hover:bg-accent'
                }`}
              >
                {role}
              </button>
            ))}
          </div>
        </div>

        <div>
          <Text as="label" size="body-small" className="mb-3 block font-medium text-muted-foreground">
            Quais são seus maiores desafios hoje?
          </Text>
          <div className="flex flex-wrap gap-2">
            {USE_CASE_OPTIONS.map((useCase) => (
              <button
                key={useCase}
                type="button"
                onClick={() => toggleUseCase(useCase)}
                className={`rounded-full border px-4 py-2 text-sm font-medium transition-colors ${
                  data.use_cases.includes(useCase)
                    ? 'border-border bg-accent text-foreground'
                    : 'border-border bg-background text-muted-foreground hover:border-border hover:bg-accent'
                }`}
              >
                {useCase}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
